<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-6">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.SHARED_POST'"> </span> </h3>
                        </div>                        
                    </div>
                </div>
                <!--end breadcrumb-->



                <section class="inner-section-wrap">

                    <!-- Table Block Start -->
                    <div class="table-wrap px-3 py-4 dark-bg border-radius5">

                          <!-- Table Start -->
                          <div class="table-responsive table-block">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.CATEGORY'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.TYPE'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.FREE'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.CREATED_AT'"> </span>
                                        </th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of albumListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td scope="row">
                                            <img  loading="lazy"  class="video-img" [src]="item.thumbnail" style="height:100px;width:150px">
                                        </td>
                                        <td>{{item.name}}</td>
                                        <td *ngIf="item.post_category==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.post_category==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
                                        <td *ngIf="item.post_type==1"><span [translate]="'GREATER.VIDEO'"> </span></td>
                                        <td *ngIf="item.post_type==2"><span [translate]="'GREATER.IMAGE'"> </span></td>
                                        <td *ngIf="item.post_type==3"><span [translate]="'GREATER.DOCUMENT'"> </span></td>
                                        <td *ngIf="item.is_content_free==false">Subscription</td>
                                        <td *ngIf="item.is_content_free==true">Free</td>                                                                                                
                                        <td>{{service.convertDate(item.createdAt)}}
                                            <!-- {{service.ToDate(item.createdAt)}} -->

                                        </td>
                                        <td class="greenlight-color font-w-bold">Published</td>
                                        <td class="action-btn-box">
                                            <a href="javascript:void(0);" (click)="redirect(item)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="pagination-block pt-4">
                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getData((p = $event))" class="text-center" *ngIf="albumListing.length > 0"></pagination-controls>
                        </div>                      
                    </div>
                    <!-- Table Block End -->
                </section>
            </div>
        </div>
        <!--end page wrapper -->

    </div>
    <app-footer></app-footer>
</main>